/**
 * ECM Progress Notes Report (TRUS-265) — route wrapper.
 *
 * There were TWO implementations of this report against the same endpoint, and
 * they showed different columns:
 *
 *   - components/reports/EcmProgressNotesReport.tsx, mounted inside the Analytics
 *     dashboard's Report Library (the entry under Reports in the nav), with
 *     member / LCM / category / status pickers and a search box;
 *   - a second table built into THIS file, reachable only via the command palette
 *     (Cmd/Ctrl-K, tab id `ecm-progress-notes-report`).
 *
 * Same data, two tables, and whichever one you happened to open decided which
 * fields you saw — so "the report" meant different things to different people.
 * This file is now a thin wrapper: both routes render the one component, so the
 * columns can no longer drift apart.
 *
 * Access is unchanged and enforced server-side (require_ops_or_higher:
 * super_admin / org_admin / ops_admin); the current org comes from the X-CBO-ID
 * header set by apiClient.
 */

import React from 'react';
import EcmProgressNotesReport from '@/components/reports/EcmProgressNotesReport';
import { PageHeader, PageContainer } from '@/components/weavein';

export default function EcmProgressNotesReportPage() {
  return (
    <div className="flex h-full flex-col">
      <PageHeader
        eyebrow="Reports · ECM"
        title="Progress Notes Report"
        description="Cross-member ECM progress notes for your organization, with the coded billing fields and CSV export."
      />
      <PageContainer>
        <EcmProgressNotesReport />
      </PageContainer>
    </div>
  );
}
